import { categories } from "../../../mocks/videos";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-1">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-eye-fill text-xl" />
              </span>
              <span className="font-heading text-lg font-black text-foreground-900">
                吃瓜爆网
              </span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              专注爆款视频合集盘点与出圈短视频热门速递，把全网真正值得看的内容，精选后送到你面前。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="#top"
                className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 text-foreground-600 transition-colors hover:border-primary-400 hover:text-primary-600"
                aria-label="分享到微博"
              >
                <i className="ri-weibo-line" />
              </a>
              <a
                href="#top"
                className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 text-foreground-600 transition-colors hover:border-primary-400 hover:text-primary-600"
                aria-label="分享到微信"
              >
                <i className="ri-wechat-line" />
              </a>
              <a
                href="#top"
                className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 text-foreground-600 transition-colors hover:border-primary-400 hover:text-primary-600"
                aria-label="联系我们"
              >
                <i className="ri-mail-line" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wide text-foreground-400">
              内容栏目
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm">
              <li>
                <a href="#collections" className="text-foreground-600 hover:text-primary-600">
                  今日爆款合集
                </a>
              </li>
              <li>
                <a href="#rank" className="text-foreground-600 hover:text-primary-600">
                  实时热度榜
                </a>
              </li>
              <li>
                <a href="#topics" className="text-foreground-600 hover:text-primary-600">
                  本周热议话题
                </a>
              </li>
              <li>
                <a href="#about" className="text-foreground-600 hover:text-primary-600">
                  关于我们
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wide text-foreground-400">
              看点分类
            </h4>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm">
              {categories.slice(1).map((c) => (
                <li key={c.id}>
                  <a
                    href="#collections"
                    className="text-foreground-600 hover:text-accent-600"
                  >
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wide text-foreground-400">
              联系方式
            </h4>
            <ul className="mt-4 flex flex-col gap-3 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-600" />
                hello@chiguabaowang.example.com
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-accent-600" />
                内容团队每日 9:00 - 21:00 在线
              </li>
              <li>
                <a
                  href="#faq"
                  className="inline-flex cursor-pointer items-center gap-1.5 rounded-full bg-background-50 px-4 py-2 text-foreground-700 transition-colors hover:bg-accent-500 hover:text-background-50"
                >
                  <i className="ri-chat-smile-3-line" /> 前往查看 FAQ
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-sm text-foreground-500">
            © {year} 吃瓜爆网 · 本平台仅做内容推荐与点评，坚持尊重原创版权
          </p>
          <p className="text-sm text-foreground-500">
            <a href="#top" className="hover:text-primary-600">回到顶部</a>
            <span className="mx-2">·</span>
            出圈短视频 · 爆款合集 · 每日更新
          </p>
        </div>
      </div>
    </footer>
  );
}